import { forwardRef, ReactNode } from 'react';

import { useBehavioralTrackingProps } from '../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import { mergeProps } from '../../core/utils/merge-props.js';
import { Flex } from '../../layouts/flex/Flex.js';

//#region Typings
/**
 * Accepted properties for the ToggleButtonGroup Prefix.
 * @public
 */
export interface ToggleButtonGroupPrefixProps
  extends StylingProps, DataTestId, BehaviorTrackingProps {
  /** Elements to be displayed in the Button Prefix slot. */
  children: ReactNode;
}
//#endregion

/**
 * ToggleButtonGroup Prefix component.
 * @public
 */
export const Prefix = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  ToggleButtonGroupPrefixProps
>(({ children, ...rest }, forwardedRef) => {
  const [behavioralTrackingProps, restProps] = useBehavioralTrackingProps(rest);

  return (
    <Flex
      ref={forwardedRef}
      gap={0}
      {...mergeProps(restProps, behavioralTrackingProps)}
    >
      {children}
    </Flex>
  );
});

(Prefix as typeof Prefix & { displayName: string }).displayName =
  'ToggleButtonGroup.Prefix';
